import { render } from "./ComplianceHome.vue?vue&type=template&id=9d09b0dc&scoped=true"
import script from "./ComplianceHome.vue?vue&type=script&lang=js"
export * from "./ComplianceHome.vue?vue&type=script&lang=js"

import "./ComplianceHome.vue?vue&type=style&index=0&id=9d09b0dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d09b0dc"]])

export default __exports__